import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Chip, pluralize } from "../../helpers/general";
import { useBookingQuery } from "../../hooks/bookings/useBookingQuery";
import { general } from "../../locales/general";
import BookingFilters from "../../pages/Bookings/BookingFilters";
import BookingTable from "../../pages/Bookings/BookingTable";
import { cardStyle } from "../../pages/Places/PlacesTable";
import FilterIcon from "../icons/FitlerIcon";
import FiltersModel, { FieldConfig } from "../ui/FiltersModel";
import Pagination from "../ui/Pagination";
import RenderTable from "../ui/RenderTable";

const bookingsFilter: FieldConfig[] = [
  {
    field: "date",
    type: "date",
    label: "Date de réservation",
    operators: ["$eq", "$gt", "$lt", "$gte", "$lte", "$between"],
  },
];

export const BookingTab: React.FC<{ userEmail: string }> = ({ userEmail }) => {
  const { id } = useParams<{ id: string }>();
  const {
    bookings,
    fetchingBookings,
    totalItems,
    currentPage,
    setCurrentPage,
    isPreviousData,
    totalCount,
    setFilters: setBookingFilters,
  } = useBookingQuery();

  const [filters, setFilters] = useState([]);
  const [filtersVisible, setFiltersVisible] = useState(false);

  useEffect(() => {
    setBookingFilters(filters);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filters]);

  const isGuest = userEmail === "guest-user@venez.ma";

  return (
    <div
      style={
        isGuest
          ? {
              background:
                "radial-gradient(ellipse at center, white 0%, #f6b186 100%)",
              borderRadius: 16,
              padding: 16,
            }
          : undefined
      }
    >
      {/* Title + count */}
      <div className="d-flex align-items-center gap-2 mb-3 ms-4">
        <h5 className="fs-5 fw-bold mb-0">Réservations</h5>
        <Chip tone="warning">
          {totalCount} {pluralize("Réservation", totalCount)}
        </Chip>
      </div>

      <FiltersModel
        open={filtersVisible}
        onClose={() => setFiltersVisible(false)}
        configs={bookingsFilter}
        callback={(filters) => setFilters(filters)}
      />

      {/* Filters */}
      <div
        style={{ ...cardStyle, padding: "12px 16px" }}
        className="d-flex flex-wrap align-items-center gap-2 mb-3"
      >
        <button
          type="button"
          onClick={() => setFiltersVisible(true)}
          className="btn btn-outline-danger rounded-pill d-flex align-items-center gap-2 px-3"
        >
          <FilterIcon />
        </button>
        <BookingFilters disableFilters={false} mode="user" userId={id} />
      </div>

      {/* Table */}
      <div style={{ ...cardStyle, padding: 0, overflow: "hidden" }}>
        <RenderTable
          loading={fetchingBookings || isPreviousData}
          render={() =>
            bookings?.length > 0 ? (
              <BookingTable bookings={bookings} />
            ) : (
              <p className="text-center text-muted py-5 mb-0">
                {general.fr.noData}
              </p>
            )
          }
        />
      </div>

      <Pagination
        currentPage={currentPage}
        onPageChange={setCurrentPage}
        siblingCount={1}
        totalCount={totalItems}
        pageSize={10}
      />
    </div>
  );
};
